/**
 * Mahalaxmi Gajak Bhandar - Lead / Contact Number Popup Controller
 * 
 * 1. Collects 10-digit Indian Mobile Number (+91)
 * 2. Est. Year 1981
 * 3. Logged in customer -> ZERO POPUP
 * 4. Already Subscribed -> Never show again (localStorage 'mgb_newsletter_subscribed')
 * 5. Dismissed -> 7-Day cooldown before showing again (localStorage 'mgb_newsletter_dismissed_time')
 * 6. Current Session -> Never show more than once in same session (sessionStorage 'mgb_newsletter_session_seen')
 * 7. Cart / Checkout / Account paths -> Suppressed
 * 8. Triggers: 3.5s delay or 25% page scroll
 * 9. Native Shopify customer form submit: Automatically registers lead in Shopify Admin -> Customers
 *    with Name = Only Number (until real name is known), Phone, Lead Note, and Tags.
 */
(function() {
  'use strict';

  function initNewsletterPopup() {
    const popup = document.querySelector('[data-account-popup]');
    if (!popup) return;

    // Check if form was just submitted successfully via server POST
    const isSuccess = popup.classList.contains('is-posted-success') || 
                      window.location.search.includes('customer_posted=true') ||
                      window.location.hash.includes('MahalaxmiNewsletterForm');

    if (isSuccess && popup.querySelector('.newsletter-popup__success')) {
      try {
        localStorage.setItem('mgb_newsletter_subscribed', 'true');
        sessionStorage.setItem('mgb_newsletter_session_seen', 'true');
      } catch(e) {}
      
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');

      setTimeout(function() {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
      }, 4000);

      // Clean URL parameters without reloading
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      return;
    }

    // 1. SUPPRESSION CHECK: Transactional URLs
    const path = (window.location.pathname || '').toLowerCase();
    if (
      path.includes('/cart') || 
      path.includes('/checkouts') || 
      path.includes('/checkout') || 
      path.includes('/account') || 
      path.includes('/challenge')
    ) {
      return;
    }

    // 2. SUPPRESSION CHECK: Customer Logged In
    if (
      document.body.classList.contains('customer-logged-in') || 
      window.isCustomerLoggedIn === true
    ) {
      return;
    }

    // 3. SUPPRESSION CHECK: Already Subscribed
    try {
      if (localStorage.getItem('mgb_newsletter_subscribed') === 'true') {
        return;
      }
    } catch(e) {}

    // 4. SUPPRESSION CHECK: 7-Day Dismissal Cooldown
    try {
      const dismissedTime = parseInt(localStorage.getItem('mgb_newsletter_dismissed_time') || '0', 10);
      const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
      if (dismissedTime && (Date.now() - dismissedTime < SEVEN_DAYS_MS)) {
        return;
      }
    } catch(e) {}

    // 5. SUPPRESSION CHECK: Seen in current session
    try {
      if (sessionStorage.getItem('mgb_newsletter_session_seen') === 'true') {
        return;
      }
    } catch(e) {}

    let hasTriggered = false;
    let timerId = null;

    function openPopup() {
      if (hasTriggered) return;
      hasTriggered = true;
      if (timerId) clearTimeout(timerId);
      window.removeEventListener('scroll', onScrollTrigger);

      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');

      try {
        sessionStorage.setItem('mgb_newsletter_session_seen', 'true');
      } catch(e) {}

      // Focus on phone input smoothly
      setTimeout(function() {
        const phoneInput = popup.querySelector('#PopupPhoneInput');
        if (phoneInput) phoneInput.focus({ preventScroll: true });
      }, 400);
    }

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');

      // Record 7-day cooldown timestamp
      try {
        localStorage.setItem('mgb_newsletter_dismissed_time', Date.now().toString());
        sessionStorage.setItem('mgb_newsletter_session_seen', 'true');
      } catch(e) {}
    }

    // Bind Close Handlers
    popup.querySelectorAll('[data-account-popup-close]').forEach(function(btn) {
      btn.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup();
      }
    });

    // Form inputs & Submission logic
    const form = popup.querySelector('#MahalaxmiNewsletterForm');
    const phoneInput = form ? form.querySelector('#PopupPhoneInput') : null;
    const phoneBox = form ? form.querySelector('.newsletter-popup__phone-box') : null;
    const submitBtn = form ? form.querySelector('.newsletter-popup__submit-btn') : null;

    const hiddenEmail = form ? form.querySelector('#PopupHiddenEmail') : null;
    const hiddenPhone = form ? form.querySelector('#PopupHiddenPhone') : null;
    const hiddenFirst = form ? form.querySelector('#PopupHiddenFirstName') : null;
    const hiddenLast = form ? form.querySelector('#PopupHiddenLastName') : null;
    const hiddenNote = form ? form.querySelector('#PopupHiddenNote') : null;
    const hiddenTags = form ? form.querySelector('#PopupHiddenTags') : null;

    function syncHiddenFields(digits) {
      if (!digits || digits.length < 10) return;
      const clean10 = digits.slice(-10);
      if (hiddenPhone) hiddenPhone.value = '+91' + clean10;
      if (hiddenEmail) hiddenEmail.value = 'lead.' + clean10 + '@mahalaxmigajak.com';
      // User directive: Name me ONLY number aayega (until real name is known)
      if (hiddenFirst) hiddenFirst.value = clean10;
      if (hiddenLast) hiddenLast.value = '';
      if (hiddenNote) hiddenNote.value = 'Website Lead - Mobile: +91 ' + clean10;
      if (hiddenTags) hiddenTags.value = 'lead, phone_lead, website_lead, newsletter, mobile_' + clean10;
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function() {
        const raw = this.value.replace(/[^0-9]/g, '');
        if (this.value !== raw) {
          this.value = raw.slice(0, 10);
        } else if (this.value.length > 10) {
          this.value = this.value.slice(0, 10);
        }
        if (phoneBox) {
          phoneBox.style.borderColor = '';
          phoneBox.style.boxShadow = '';
        }
        if (this.value.length === 10) {
          syncHiddenFields(this.value);
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function(e) {
        const raw = phoneInput ? phoneInput.value.replace(/[^0-9]/g, '') : '';
        if (raw.length < 10) {
          e.preventDefault();
          if (phoneInput) phoneInput.focus();
          if (phoneBox) {
            phoneBox.style.borderColor = '#ef3e2f';
            phoneBox.style.boxShadow = '0 0 0 3px rgba(239, 62, 47, 0.15)';
          }
          return;
        }

        // 10 digits valid! Populate all Shopify Customer fields with pure phone number as name
        syncHiddenFields(raw);

        if (submitBtn) {
          submitBtn.style.pointerEvents = 'none';
          submitBtn.innerHTML = '<span>Saving...</span>';
        }
        // Native submission proceeds seamlessly without e.preventDefault()
      });
    }

    // TRIGGER 1: 3.5 Second Delay
    timerId = setTimeout(openPopup, 3500);

    // TRIGGER 2: 25% Scroll Trigger
    function onScrollTrigger() {
      const scrollPos = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 300 && (scrollPos / docHeight) >= 0.25) {
        openPopup();
      }
    }
    window.addEventListener('scroll', onScrollTrigger, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }
})();
